import getCookie from './getCookie';
import axios from 'axios';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
function initInterceptor() {
    // Interceptor cho request - Đọc token từ cookie trước mỗi request
    axios.interceptors.request.use(
        (config) => {
            // Bỏ qua việc thêm Authorization header cho endpoint login
            const isLoginRequest = config.url && config.url.includes('/cus/login');

            if (!isLoginRequest) {
                const token = getCookie('tk');
                if (token) {
                    config.headers['Authorization'] = token;
                }
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    // Interceptor cho response - Xử lý lỗi 401 và 403
    axios.interceptors.response.use(
        (response) => {
            if (201 === response.status) {
                toast.success('Thao tác thành công', {
                    position: 'bottom-right',
                    autoClose: 4000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined
                });
            }
            return response;
        },
        (error) => {
            console.log(error);
            if (400 === error.response.status) {
                const token = getCookie('tk');
                if (token) {
                    toast.error('Đã có lỗi xẩy ra', {
                        position: 'top-right',
                        autoClose: 4000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined
                    });
                }
            } else if (401 === error.response.status) {
                window.location = '/logout';
            } else if (403 === error.response.status) {
                // alert("Bạn không có quyền truy cập")
                window.location = '/login';
                return Promise.reject(error);
            } else {
                return Promise.reject(error);
            }
        }
    );
}
const interceptorService = {
    initInterceptor
};
export default interceptorService;
